import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'

interface RatersProps {
	total: number
	rating?: number
	onRate: ({ rating }: { rating: number }) => void
}

export function Raters({
	total = 1,
	rating = 0,
	onRate,
	...props
}: RatersProps) {
	const [selected, setSelected] = useState(rating)
	const [positionHover, setPositionHover] = useState(0)

	const handleRaters = (rating: number) => {
		setSelected((current) => (current === rating ? 0 : rating))
	}

	useEffect(() => {
		onRate({ rating: selected })
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selected])

	return (
		<>
			{Array.from({ length: total }, (_, key) => {
				const index = key + 1
				return (
					<div
						key={index}
						className='group px-2 cursor-pointer'
						onMouseEnter={() => setPositionHover(index)}
						onMouseLeave={() => setPositionHover(0)}
						onClick={() => handleRaters(index)}
						{...props}
					>
						<svg
							width='30'
							height='29'
							viewBox='0 0 30 29'
							key={index}
							className={twMerge(
								'text-white group-hover:text-brand-primary',
								classNames({
									'text-brand-primary':
										positionHover >= index || selected >= index,
								})
							)}
						>
							<path
								d='M13.5922 2.21973C14.2902 1.26009 15.7098 1.26009 16.4078 2.21972L19.6783 6.71608C20.2633 7.52026 21.0853 8.12116 22.0296 8.43278L27.2942 10.1701C28.414 10.5396 28.8652 11.908 28.1657 12.882L24.9224 17.3982C24.3424 18.2058 24.0294 19.1749 24.0264 20.1692L24.0097 25.7392C24.006 26.943 22.8449 27.774 21.7303 27.4137L16.4553 25.7085C15.5091 25.4026 14.4909 25.4026 13.5447 25.7085L8.26967 27.4137C7.15508 27.774 5.99397 26.943 5.99035 25.7392L5.97357 20.1692C5.97057 19.1749 5.65763 18.2058 5.07764 17.3982L1.8343 12.882C1.13482 11.908 1.58601 10.5396 2.70579 10.1701L7.97042 8.43278C8.91473 8.12116 9.73672 7.52026 10.3217 6.71608L13.5922 2.21973Z'
								fill='currentColor'
								stroke='rgb(203, 213, 225)'
								strokeWidth='3'
								className={twMerge(
									'group-hover:stroke-none',
									classNames({
										'stroke-none': positionHover >= index || selected >= index,
									})
								)}
							></path>
						</svg>
					</div>
				)
			})}
		</>
	)
}

export default Raters
